import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “I really wanted to take this time to thank We Rock the Spectrum for such an AMAZING establishment. Our son has autism and has severe sensory issues and does not to well with big crowds so this place was perfect ! His father and I couldn’t have ask for a better way to celebrate his third birthday with our family ! I would highly recommend this establishment to host your children’s birthdays or just taking them there for some active fun play! The back room is spacious and love that we were able to decorate and provide our own food! Everyone who works there is extremely professional and responds in a timely manner! So thank you again to we rock the spectrum for allowing us to enjoy our son’s birthday!” </p>
                            <p className="overview">Brenda M. – Brookfield</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “We went to We Rock The Spectrum for a small group reservation on a Sunday morning. The kids (aged 3 and under) had a great time playing with the kitchen, grocery store, work bench and other toys. They also liked the trampoline and zip line. We thought the place was really fun. Todd, one of the business owners, was very helpful and accommodating. We will be back in the future.”</p>
                            <p className="overview">Tyler S. – Chicagoland </p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “I attended a couple of birthday parties in this playroom, and since I liked it, we decided to have a party here for our 2-year-old son. The experience is really amazing! First of all, the space is equipped for children of all ages (from babies to big kids who have a trampoline and a zip line at their disposal)! All the children who were at the birthday party were delighted! Secondly, the party room is also good! There is enough room for approximately 30 people. Definitely enough space for everything. Thirdly, the service is impeccable! The new owners are really wonderful people, very flexible, easy to negotiate, helpful, kind… I have no words! Indeed all the praises! They are good organizers, and have great ideas that will improve this place even more! I would definitely recommend this place to everyone and for sure will come back!”</p>
                            <p className="overview">Marina B. – Des Plaines </p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Spent a few hours there with our autistic son and it was great! Owners were engaged and supportive. Other parents understanding and kids got to enjoy themselves. Nice variety and loved the calming room. Super cute to get kids out of the house and allow to explore and release energy. Thank you for providing this awesome service!”</p>
                            <p className="overview">VS – Chicagoland </p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “This place is amazing! Not only can you rent it out for your child’s birthday party but they also offer open gym and Toddler Tuesdays. We celebrated our son’s 2nd birthday party here and he had a blast! There’s something for all kids even my 10 year old nephew had fun with the zip line. Beth and Todd were so helpful and very accommodating for our party. There’s different party packages for you to choose from and we loved that it’s a private party only for you and your guest. I definitely recommend We Rock the Spectrum for party time or play time.”</p>
                            <p className="overview">Laura G. – Westchester </p>
                        </div>
                       
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
